module.exports = __webpack_public_path__ + "static/img/MM@2x.324774a0.jpg";